import { Controller } from '@hotwired/stimulus';

class JoinTokensController extends Controller {
  static targets = ['joinModal', 'joinModalFrame'];

  static classes = ['openModal'];

  connect() {}

  openJoinModal() {
    this.joinModalFrameTarget.setAttribute(
      'src',
      this.joinModalFrameTarget.getAttribute('orig-src'),
    );
    this.joinModalTarget.classList.add(this.openModalClass);
  }

  closeJoinModal() {
    this.joinModalTarget.classList.remove(this.openModalClass);
    this.joinModalFrameTarget.removeAttribute('src');
  }
}

export default JoinTokensController;
